// Auto-generated version file - DO NOT EDIT
// Generated at: 2025-09-02T10:17:09.918Z

export interface VersionInfo {
  version: string;
  gitHash: string;
  gitBranch: string;
  gitDate: string;
  buildTime: string;
  buildTimestamp: number;
}

export const VERSION_INFO: VersionInfo = {
  "version": "432c7e6-20250902T1017",
  "gitHash": "432c7e6",
  "gitBranch": "main",
  "gitDate": "2025-09-02 01:10:08 +0300",
  "buildTime": "2025-09-02T10:17:09.918Z",
  "buildTimestamp": 1756808229935
};

export const getVersionString = () => VERSION_INFO.version;
export const getFullVersionInfo = () => VERSION_INFO;
